import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';

export interface ClientRecipeRateDTO {
  recipe_id: string;
  recipe_codigo: string;
  recipe_nombre: string;
  porcentaje_utilidad: number;
  source_proforma_id: string | null;
  updated_at: string;
}

// Map recipeId → porcentaje_utilidad for fast lookups
export type ClientRatesMap = Map<string, number>;

// Returns Map<recipeId, utilidad> — used by ProformaBuilder for fast lookups
export function useClientRecipeRates(clientId: string | null | undefined) {
  return useQuery({
    queryKey: ['clientRecipeRates', clientId],
    queryFn: async () => {
      const response = await api.get<{ data: ClientRecipeRateDTO[] }>(
        `/clients/${clientId}/recipe-rates`,
      );
      return response.data.data;
    },
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000, // 5 min — doesn't change often
    select: (data): ClientRatesMap => {
      const map = new Map<string, number>();
      for (const r of data) {
        map.set(r.recipe_id, r.porcentaje_utilidad);
      }
      return map;
    },
  });
}

// Returns raw array — used by ClientDetailPanel to display the rates table
export function useClientRecipeRatesList(clientId: string | null | undefined) {
  return useQuery({
    queryKey: ['clientRecipeRates', clientId],
    queryFn: async () => {
      const response = await api.get<{ data: ClientRecipeRateDTO[] }>(
        `/clients/${clientId}/recipe-rates`,
      );
      return response.data.data;
    },
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}
